<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { currencyFormatter } from 'next/message/bubbles/Lazada/helper/formatter.js';
import { computed, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
const props = defineProps({
  cached: {
    type: Object,
    required: true,
  },
});
const { t } = useI18n();
const imageUrl = computed(() => {
  return props.cached?.meta?.imageUrls?.[0] || null;
});

const externalUrl = computed(() => {
  return props.cached?.meta?.externalUrl || null;
});

const productName = computed(() => {
  return props.cached?.name || '';
});

const productPrice = computed(() => {
  const price = props.cached?.meta?.price;
  return currencyFormatter(price || 0);
});
</script>

<template>
  <a
    :href="externalUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="no-underline"
  >
    <div class="lazada-item max-w-md w-full">
      <p class="flex items-center gap-2 border-b border-slate-100 pb-2">
        <Icon icon="i-ri-box-3-fill" />
        <span class="font-semibold text-base">
          {{ t('CONVERSATION.LAZADA.PRODUCTS.LABEL') }}
        </span>
      </p>

      <div class="flex items-start gap-4 pt-2">
        <img
          :src="imageUrl"
          alt="Product Image"
          class="w-32 h-auto rounded-lg object-cover flex-shrink-0"
        />

        <div class="flex flex-col justify-center max-w-full">
          <span class="text-sm break-words whitespace-normal leading-snug">
            {{ productName }}
          </span>
          <span class="text-sm font-semibold text-woot-600 mt-1">
            {{ productPrice }}
          </span>
        </div>
      </div>
    </div>
  </a>
</template>

<style lang="scss">
.lazada-item {
  @apply bg-white dark:bg-n-slate-4 p-4 rounded-lg shadow-lg mb-4 flex flex-col;
}
</style>
